import { interfaceIds } from '@soundxyz/sound-protocol/interfaceIds';

const HANDLED_MINTER_INTERFACE_IDS = [
  interfaceIds.IMerkleDropMinter,
  interfaceIds.IMerkleDropMinterV2,
  interfaceIds.IMerkleDropMinterV2_1,
  interfaceIds.IRangeEditionMinter,
  interfaceIds.IRangeEditionMinterV2,
  interfaceIds.IRangeEditionMinterV2_1
];
function isHandledMinterInterfaceId(interfaceId) {
  return HANDLED_MINTER_INTERFACE_IDS.findIndex((value) => value === interfaceId) !== -1;
}
const HANDLED_SAM_INTERFACE_IDS = [interfaceIds.ISAM, interfaceIds.ISAMV1_1];
function isRangeEditionSchedule(schedule) {
  return schedule.mintType === "RangeEdition";
}
function isMerkleDropSchedule(schedule) {
  return schedule.mintType === "MerkleDrop";
}

export { HANDLED_MINTER_INTERFACE_IDS, HANDLED_SAM_INTERFACE_IDS, isHandledMinterInterfaceId, isMerkleDropSchedule, isRangeEditionSchedule };
